import { render, staticRenderFns } from "./RechargeWallet.vue?vue&type=template&id=95c5670a&scoped=true"
import script from "./RechargeWallet.vue?vue&type=script&lang=js"
export * from "./RechargeWallet.vue?vue&type=script&lang=js"
import style0 from "./RechargeWallet.vue?vue&type=style&index=0&id=95c5670a&prod&scoped=true&lang=css"
import style1 from "./RechargeWallet.vue?vue&type=style&index=1&id=95c5670a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c5670a",
  null
  
)

export default component.exports